export default __webpack_public_path__ + "static/media/12.73a3ff2e.jpeg";